import { toString, Record, Union } from "../fable_modules/fable-library.3.7.20/Types.js";
import { unit_type, equals, obj_type, tuple_type, option_type, record_type, list_type, union_type, bool_type, float64_type, int32_type, class_type, string_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { parseBool, parseDouble, parseInt$, parseDateTime, DateTimeExtensions_to1stInMonth, DateTimeExtensions_yyyy_MM_dd, logei } from "../Utils.js";
import { toFail, printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { fromString, bool, list as list_3, string, int, object } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { bind, map as map_1, defaultArg } from "../fable_modules/fable-library.3.7.20/Option.js";
import { map2, item, map, empty } from "../fable_modules/fable-library.3.7.20/List.js";
import { now, addMonths } from "../fable_modules/fable-library.3.7.20/Date.js";
import { parse } from "../fable_modules/fable-library.3.7.20/DateOnly.js";
import { UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { getCsrfEnabledRequest, Http_get_ExtraCoders, ValidatedUrlModule_value, addClientReference } from "../HttpV2.js";
import { BodyContent, HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { queryString } from "../fable_modules/Svea.Dry.Fable.1.0.4/Http.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString as fromString_1 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString as toString_1 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";

export class BoxedDataType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String", "Date", "DateTime", "Integer", "Float", "Boolean", "Binary", "Nothing", "Unknown"];
    }
}

export function BoxedDataType$reflection() {
    return union_type("Api.DataSet.BoxedDataType", [], BoxedDataType, () => [[["Item", string_type]], [["Item", class_type("System.DateOnly")]], [["Item", class_type("System.DateTime")]], [["Item", int32_type]], [["Item", float64_type]], [["Item", bool_type]], [["Item", string_type]], [], []]);
}

export class DataType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String", "Date", "DateTime", "Integer", "Float", "Boolean", "Binary", "Unknown"];
    }
}

export function DataType$reflection() {
    return union_type("Api.DataSet.DataType", [], DataType, () => [[], [], [], [], [], [], [], []]);
}

export function DataType_ofString_Z721C83C5(str) {
    const matchValue = str.toLocaleLowerCase();
    switch (matchValue) {
        case "string": {
            return new DataType(0);
        }
        case "date": {
            return new DataType(1);
        }
        case "datetime": {
            return new DataType(2);
        }
        case "integer": {
            return new DataType(3);
        }
        case "float": {
            return new DataType(4);
        }
        case "boolean": {
            return new DataType(5);
        }
        case "binary": {
            return new DataType(6);
        }
        default: {
            logei(toText(printf("[DataTypes.ofString] Unable to parse: %s"))(matchValue));
            return new DataType(7);
        }
    }
}

export class JobConfig extends Record {
    constructor(ClientNr, CronString, Mail, Save) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.CronString = CronString;
        this.Mail = Mail;
        this.Save = Save;
    }
}

export function JobConfig$reflection() {
    return record_type("Api.DataSet.JobConfig", [], JobConfig, () => [["ClientNr", int32_type], ["CronString", string_type], ["Mail", list_type(string_type)], ["Save", bool_type]]);
}

export function JobConfig_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3;
        return new JobConfig((objectArg = get$.Required, objectArg.Field("ClientNr", uncurry(2, int))), (objectArg_1 = get$.Required, objectArg_1.Field("CronString", string)), (objectArg_2 = get$.Required, objectArg_2.Field("Mail", (path_2, value_2) => list_3(string, path_2, value_2))), (objectArg_3 = get$.Required, objectArg_3.Field("Save", bool)));
    }, path_4, v));
}

export class Serie extends Record {
    constructor(Type, Title, DataKey, Axis) {
        super();
        this.Type = Type;
        this.Title = Title;
        this.DataKey = DataKey;
        this.Axis = Axis;
    }
}

export function Serie$reflection() {
    return record_type("Api.DataSet.Serie", [], Serie, () => [["Type", string_type], ["Title", string_type], ["DataKey", string_type], ["Axis", option_type(string_type)]]);
}

export function Serie_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg_2, objectArg_3;
        let Type;
        const objectArg = get$.Required;
        Type = objectArg.Field("Type", string);
        let DataKey;
        const objectArg_1 = get$.Required;
        DataKey = objectArg_1.Field("DataKey", string);
        return new Serie(Type, (objectArg_2 = get$.Required, objectArg_2.Field("Title", string)), DataKey, (objectArg_3 = get$.Optional, objectArg_3.Field("Axis", string)));
    }, path_4, v));
}

export class Chart extends Record {
    constructor(Title, Series, Query, UseMainQuery) {
        super();
        this.Title = Title;
        this.Series = Series;
        this.Query = Query;
        this.UseMainQuery = UseMainQuery;
    }
}

export function Chart$reflection() {
    return record_type("Api.DataSet.Chart", [], Chart, () => [["Title", string_type], ["Series", list_type(Serie$reflection())], ["Query", string_type], ["UseMainQuery", bool_type]]);
}

export function Chart_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, arg_3, decoder, objectArg_1, objectArg_2, objectArg_3;
        return new Chart((objectArg = get$.Required, objectArg.Field("Title", string)), (arg_3 = ((decoder = Serie_get_Decoder(), (path_1) => ((value_1) => list_3(uncurry(2, decoder), path_1, value_1)))), (objectArg_1 = get$.Required, objectArg_1.Field("Series", uncurry(2, arg_3)))), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("Query", string)), ""), defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("UseMainQuery", bool)), false));
    }, path_4, v));
}

export function Chart_get_Default() {
    return new Chart("", empty(), "", false);
}

export class ChartConfig extends Record {
    constructor(Charts) {
        super();
        this.Charts = Charts;
    }
}

export function ChartConfig$reflection() {
    return record_type("Api.DataSet.ChartConfig", [], ChartConfig, () => [["Charts", list_type(Chart$reflection())]]);
}

export function ChartConfig_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let arg_1, decoder, objectArg;
        return new ChartConfig((arg_1 = ((decoder = Chart_get_Decoder(), (path) => ((value) => list_3(uncurry(2, decoder), path, value)))), (objectArg = get$.Required, objectArg.Field("Charts", uncurry(2, arg_1)))));
    }, path_1, v));
}

export class Presentation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ShowAll", "ShowActiveOnly", "ShowInactiveOnly"];
    }
}

export function Presentation$reflection() {
    return union_type("Api.DataSet.Presentation", [], Presentation, () => [[], [], []]);
}

export function Presentation_ToString_Z554539E7(p) {
    switch (p.tag) {
        case 1: {
            return "ShowActiveOnly";
        }
        case 2: {
            return "ShowInactiveOnly";
        }
        default: {
            return "ShowAll";
        }
    }
}

export function Presentation_OfString_Z721C83C5(str) {
    const matchValue = str.toLocaleLowerCase();
    switch (matchValue) {
        case "showall": {
            return new Presentation(0);
        }
        case "showactiveonly": {
            return new Presentation(1);
        }
        case "showinactiveonly": {
            return new Presentation(2);
        }
        default: {
            return toFail(printf("[Presentation] - OfString: Cannot parse \u0027%s\u0027 into Presentation."))(matchValue);
        }
    }
}

export function Presentation_get_GetDefault() {
    return new Presentation(0);
}

export class ContractTypeFilter extends Record {
    constructor(IsActive, Presentation) {
        super();
        this.IsActive = IsActive;
        this.Presentation = Presentation;
    }
}

export function ContractTypeFilter$reflection() {
    return record_type("Api.DataSet.ContractTypeFilter", [], ContractTypeFilter, () => [["IsActive", bool_type], ["Presentation", Presentation$reflection()]]);
}

export function ContractTypeFilter_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new ContractTypeFilter((objectArg = get$.Required, objectArg.Field("IsActive", bool)), Presentation_OfString_Z721C83C5((objectArg_1 = get$.Required, objectArg_1.Field("Presentation", string))));
    }, path_2, v));
}

export function ContractTypeFilter_get_GetDefault() {
    return new ContractTypeFilter(false, Presentation_get_GetDefault());
}

export class PeriodFilter extends Record {
    constructor(IsActive, MonthsFrom, MonthsTo, DefaultValue) {
        super();
        this.IsActive = IsActive;
        this.MonthsFrom = (MonthsFrom | 0);
        this.MonthsTo = (MonthsTo | 0);
        this.DefaultValue = DefaultValue;
    }
}

export function PeriodFilter$reflection() {
    return record_type("Api.DataSet.PeriodFilter", [], PeriodFilter, () => [["IsActive", bool_type], ["MonthsFrom", int32_type], ["MonthsTo", int32_type], ["DefaultValue", option_type(int32_type)]]);
}

export function PeriodFilter_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3;
        return new PeriodFilter((objectArg = get$.Required, objectArg.Field("IsActive", bool)), (objectArg_1 = get$.Required, objectArg_1.Field("MonthsFrom", uncurry(2, int))), (objectArg_2 = get$.Required, objectArg_2.Field("MonthsTo", uncurry(2, int))), (objectArg_3 = get$.Optional, objectArg_3.Field("DefaultValue", uncurry(2, int))));
    }, path_1, v));
}

export function PeriodFilter_get_GetDefault() {
    return new PeriodFilter(false, 0, 0, void 0);
}

export function PeriodFilter_GetDefaultValueAsParamValue_1DF1F64A(periodFilter) {
    const matchValue = periodFilter.DefaultValue;
    if (matchValue != null) {
        const defaultValue = matchValue | 0;
        return DateTimeExtensions_yyyy_MM_dd(DateTimeExtensions_to1stInMonth(addMonths(now(), defaultValue)));
    }
    else {
        return "";
    }
}

export class Filters extends Record {
    constructor(ContractType, PeriodFrom, PeriodTo) {
        super();
        this.ContractType = ContractType;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
    }
}

export function Filters$reflection() {
    return record_type("Api.DataSet.Filters", [], Filters, () => [["ContractType", ContractTypeFilter$reflection()], ["PeriodFrom", PeriodFilter$reflection()], ["PeriodTo", PeriodFilter$reflection()]]);
}

export function Filters_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg, arg_3, objectArg_1, arg_5, objectArg_2;
        return new Filters(defaultArg((arg_1 = ContractTypeFilter_get_Decoder(), (objectArg = get$.Optional, objectArg.Field("ContractType", uncurry(2, arg_1)))), ContractTypeFilter_get_GetDefault()), defaultArg((arg_3 = PeriodFilter_get_Decoder(), (objectArg_1 = get$.Optional, objectArg_1.Field("PeriodFrom", uncurry(2, arg_3)))), PeriodFilter_get_GetDefault()), defaultArg((arg_5 = PeriodFilter_get_Decoder(), (objectArg_2 = get$.Optional, objectArg_2.Field("PeriodTo", uncurry(2, arg_5)))), PeriodFilter_get_GetDefault()));
    }, path, v));
}

export function Filters_get_GetDefault() {
    return new Filters(ContractTypeFilter_get_GetDefault(), PeriodFilter_get_GetDefault(), PeriodFilter_get_GetDefault());
}

export class RequiredClientSetting extends Record {
    constructor(SettingId, Value) {
        super();
        this.SettingId = SettingId;
        this.Value = Value;
    }
}

export function RequiredClientSetting$reflection() {
    return record_type("Api.DataSet.RequiredClientSetting", [], RequiredClientSetting, () => [["SettingId", string_type], ["Value", string_type]]);
}

export function RequiredClientSetting_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new RequiredClientSetting((objectArg = get$.Required, objectArg.Field("SettingId", string)), (objectArg_1 = get$.Required, objectArg_1.Field("Value", string)));
    }, path_2, v));
}

export class DataSetMetaData extends Record {
    constructor(ChartConfig, DataError, DataTypes, Description, Editable, Headers, HideFromMenu, JobConfig, LinksAllowed, MenuItem, MissingParameters, Query, Parent, RequiredResource, SlkOnly, Title, Filters, RequiredClientSettings, SortOrder) {
        super();
        this.ChartConfig = ChartConfig;
        this.DataError = DataError;
        this.DataTypes = DataTypes;
        this.Description = Description;
        this.Editable = Editable;
        this.Headers = Headers;
        this.HideFromMenu = HideFromMenu;
        this.JobConfig = JobConfig;
        this.LinksAllowed = LinksAllowed;
        this.MenuItem = MenuItem;
        this.MissingParameters = MissingParameters;
        this.Query = Query;
        this.Parent = Parent;
        this.RequiredResource = RequiredResource;
        this.SlkOnly = SlkOnly;
        this.Title = Title;
        this.Filters = Filters;
        this.RequiredClientSettings = RequiredClientSettings;
        this.SortOrder = SortOrder;
    }
}

export function DataSetMetaData$reflection() {
    return record_type("Api.DataSet.DataSetMetaData", [], DataSetMetaData, () => [["ChartConfig", ChartConfig$reflection()], ["DataError", option_type(string_type)], ["DataTypes", list_type(DataType$reflection())], ["Description", string_type], ["Editable", bool_type], ["Headers", list_type(string_type)], ["HideFromMenu", option_type(bool_type)], ["JobConfig", option_type(JobConfig$reflection())], ["LinksAllowed", bool_type], ["MenuItem", option_type(string_type)], ["MissingParameters", list_type(tuple_type(string_type, DataType$reflection()))], ["Query", option_type(string_type)], ["Parent", option_type(string_type)], ["RequiredResource", option_type(string_type)], ["SlkOnly", bool_type], ["Title", option_type(string_type)], ["Filters", option_type(Filters$reflection())], ["RequiredClientSettings", list_type(RequiredClientSetting$reflection())], ["SortOrder", option_type(int32_type)]]);
}

export function DataSetMetaData_get_Decoder() {
    return (path_19) => ((v) => object((get$) => {
        let objectArg_2, objectArg_10, objectArg_12, objectArg_13, objectArg_14, objectArg_15, arg_34, objectArg_16, arg_36, decoder_4, objectArg_17, objectArg_18;
        let ChartConfig_1;
        const arg_1 = ChartConfig_get_Decoder();
        const objectArg = get$.Required;
        ChartConfig_1 = objectArg.Field("ChartConfig", uncurry(2, arg_1));
        let DataError;
        const objectArg_1 = get$.Optional;
        DataError = objectArg_1.Field("DataError", string);
        const DataTypes = map(DataType_ofString_Z721C83C5, (objectArg_2 = get$.Required, objectArg_2.Field("DataTypes", (path_2, value_2) => list_3(string, path_2, value_2))));
        let Description;
        const objectArg_3 = get$.Required;
        Description = objectArg_3.Field("Description", string);
        let Editable;
        const objectArg_4 = get$.Required;
        Editable = objectArg_4.Field("Editable", bool);
        let Headers;
        const objectArg_5 = get$.Required;
        Headers = objectArg_5.Field("Headers", (path_6, value_6) => list_3(string, path_6, value_6));
        let HideFromMenu;
        const objectArg_6 = get$.Optional;
        HideFromMenu = objectArg_6.Field("HideFromMenu", bool);
        let JobConfig_1;
        const arg_16 = JobConfig_get_Decoder();
        const objectArg_7 = get$.Optional;
        JobConfig_1 = objectArg_7.Field("JobConfig", uncurry(2, arg_16));
        let LinksAllowed;
        const objectArg_8 = get$.Required;
        LinksAllowed = objectArg_8.Field("LinksAllowed", bool);
        let MenuItem;
        const objectArg_9 = get$.Optional;
        MenuItem = objectArg_9.Field("MenuItem", string);
        const MissingParameters = map((missingParamsArr) => [item(0, missingParamsArr), DataType_ofString_Z721C83C5(item(1, missingParamsArr))], (objectArg_10 = get$.Required, objectArg_10.Field("MissingParameters", (path_12, value_12) => list_3((path_11, value_11) => list_3(string, path_11, value_11), path_12, value_12))));
        let Parent;
        const objectArg_11 = get$.Optional;
        Parent = objectArg_11.Field("Parent", string);
        return new DataSetMetaData(ChartConfig_1, DataError, DataTypes, Description, Editable, Headers, HideFromMenu, JobConfig_1, LinksAllowed, MenuItem, MissingParameters, (objectArg_12 = get$.Optional, objectArg_12.Field("Query", string)), Parent, (objectArg_13 = get$.Optional, objectArg_13.Field("RequiredResource", string)), (objectArg_14 = get$.Required, objectArg_14.Field("SlkOnly", bool)), (objectArg_15 = get$.Optional, objectArg_15.Field("Title", string)), (arg_34 = Filters_get_Decoder(), (objectArg_16 = get$.Optional, objectArg_16.Field("Filters", uncurry(2, arg_34)))), defaultArg((arg_36 = ((decoder_4 = RequiredClientSetting_get_Decoder(), (path_18) => ((value_18) => list_3(uncurry(2, decoder_4), path_18, value_18)))), (objectArg_17 = get$.Optional, objectArg_17.Field("RequiredClientSettings", uncurry(2, arg_36)))), empty()), (objectArg_18 = get$.Optional, objectArg_18.Field("SortOrder", uncurry(2, int))));
    }, path_19, v));
}

export class ChartObjectDTO extends Record {
    constructor(x, y1, y2, y3, y4, y5, y6) {
        super();
        this.x = x;
        this.y1 = y1;
        this.y2 = y2;
        this.y3 = y3;
        this.y4 = y4;
        this.y5 = y5;
        this.y6 = y6;
    }
}

export function ChartObjectDTO$reflection() {
    return record_type("Api.DataSet.ChartObjectDTO", [], ChartObjectDTO, () => [["x", obj_type], ["y1", option_type(obj_type)], ["y2", option_type(obj_type)], ["y3", option_type(obj_type)], ["y4", option_type(obj_type)], ["y5", option_type(obj_type)], ["y6", option_type(obj_type)]]);
}

export class ChartData extends Record {
    constructor(Title, DataTypes, Data, Series) {
        super();
        this.Title = Title;
        this.DataTypes = DataTypes;
        this.Data = Data;
        this.Series = Series;
    }
}

export function ChartData$reflection() {
    return record_type("Api.DataSet.ChartData", [], ChartData, () => [["Title", option_type(string_type)], ["DataTypes", list_type(string_type)], ["Data", list_type(ChartObjectDTO$reflection())], ["Series", list_type(Serie$reflection())]]);
}

export class ChartDataBaseObj extends Record {
    constructor(ChartData) {
        super();
        this.ChartData = ChartData;
    }
}

export function ChartDataBaseObj$reflection() {
    return record_type("Api.DataSet.ChartDataBaseObj", [], ChartDataBaseObj, () => [["ChartData", list_type(ChartData$reflection())]]);
}

export class DataSetDataV2 extends Record {
    constructor(ChartData, TableData) {
        super();
        this.ChartData = ChartData;
        this.TableData = TableData;
    }
}

export function DataSetDataV2$reflection() {
    return record_type("Api.DataSet.DataSetDataV2", [], DataSetDataV2, () => [["ChartData", ChartDataBaseObj$reflection()], ["TableData", list_type(list_type(obj_type))]]);
}

export class UpdateDataSetDTO extends Record {
    constructor(ChartConfig, JobConfig, Description, HideFromMenu, MenuItem, Parent, Query, RequiredResource, SlkOnly, Title, Filters, RequiredClientSettings, SortOrder) {
        super();
        this.ChartConfig = ChartConfig;
        this.JobConfig = JobConfig;
        this.Description = Description;
        this.HideFromMenu = HideFromMenu;
        this.MenuItem = MenuItem;
        this.Parent = Parent;
        this.Query = Query;
        this.RequiredResource = RequiredResource;
        this.SlkOnly = SlkOnly;
        this.Title = Title;
        this.Filters = Filters;
        this.RequiredClientSettings = RequiredClientSettings;
        this.SortOrder = SortOrder;
    }
}

export function UpdateDataSetDTO$reflection() {
    return record_type("Api.DataSet.UpdateDataSetDTO", [], UpdateDataSetDTO, () => [["ChartConfig", ChartConfig$reflection()], ["JobConfig", option_type(JobConfig$reflection())], ["Description", string_type], ["HideFromMenu", bool_type], ["MenuItem", string_type], ["Parent", option_type(option_type(string_type))], ["Query", option_type(string_type)], ["RequiredResource", string_type], ["SlkOnly", bool_type], ["Title", string_type], ["Filters", option_type(Filters$reflection())], ["RequiredClientSettings", list_type(RequiredClientSetting$reflection())], ["SortOrder", option_type(int32_type)]]);
}

export class DataSetMinimal extends Record {
    constructor(SetId, Title, MenuItem, Parent, SortOrder) {
        super();
        this.SetId = SetId;
        this.Title = Title;
        this.MenuItem = MenuItem;
        this.Parent = Parent;
        this.SortOrder = SortOrder;
    }
}

export function DataSetMinimal$reflection() {
    return record_type("Api.DataSet.DataSetMinimal", [], DataSetMinimal, () => [["SetId", string_type], ["Title", option_type(string_type)], ["MenuItem", string_type], ["Parent", option_type(string_type)], ["SortOrder", option_type(int32_type)]]);
}

export function transformData(dataTypes, dataSetData) {
    const jsonValueToStrOption = (jsonValue) => {
        if (jsonValue === null) {
            return void 0;
        }
        else {
            return toString(jsonValue);
        }
    };
    return map((innerData) => map2((dataType, jsonValue_1) => {
        switch (dataType.tag) {
            case 1: {
                const _arg_2 = map_1(parse, jsonValueToStrOption(jsonValue_1));
                if (_arg_2 != null) {
                    return new BoxedDataType(1, _arg_2);
                }
                else {
                    return new BoxedDataType(7);
                }
            }
            case 2: {
                const _arg_3 = bind(parseDateTime, jsonValueToStrOption(jsonValue_1));
                if (_arg_3 != null) {
                    return new BoxedDataType(2, _arg_3);
                }
                else {
                    return new BoxedDataType(7);
                }
            }
            case 3: {
                const _arg_4 = bind(parseInt$, jsonValueToStrOption(jsonValue_1));
                if (_arg_4 != null) {
                    return new BoxedDataType(3, _arg_4);
                }
                else {
                    return new BoxedDataType(7);
                }
            }
            case 4: {
                const _arg_5 = bind(parseDouble, jsonValueToStrOption(jsonValue_1));
                if (_arg_5 != null) {
                    return new BoxedDataType(4, _arg_5);
                }
                else {
                    return new BoxedDataType(7);
                }
            }
            case 5: {
                const _arg_6 = bind(parseBool, jsonValueToStrOption(jsonValue_1));
                if (_arg_6 != null) {
                    return new BoxedDataType(5, _arg_6);
                }
                else {
                    return new BoxedDataType(7);
                }
            }
            case 6: {
                return new BoxedDataType(6, jsonValue_1);
            }
            case 7: {
                return new BoxedDataType(8);
            }
            default: {
                const _arg_1 = map_1((_arg) => {
                    if (_arg === "null") {
                        return "";
                    }
                    else {
                        return _arg;
                    }
                }, jsonValueToStrOption(jsonValue_1));
                if (_arg_1 != null) {
                    return new BoxedDataType(0, _arg_1);
                }
                else {
                    return new BoxedDataType(7);
                }
            }
        }
    }, dataTypes, innerData), dataSetData);
}

export function loadMetaData(clientNr, specificReport) {
    const url = toText(printf("/SYSTEM/DataSet2/%i/%s/MetaData/"))(clientNr)(specificReport);
    let decoder_1;
    const decoder = DataSetMetaData_get_Decoder();
    decoder_1 = ((value) => fromString(uncurry(2, decoder), value));
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, url));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const caseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(DataSetMetaData$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : decoder_1(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadData(clientNr, specificReport, missingParameters) {
    const parameters = queryString(missingParameters);
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/SYSTEM/DataSet2/%i/%s/Data/%s"))(clientNr)(specificReport)(parameters)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(DataSetDataV2$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(DataSetDataV2$reflection(), arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(DataSetDataV2$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function saveDataSet(clientNr, setId, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/SYSTEM/DataSet2/%i/%s"))(clientNr)(setId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString_1(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(UpdateDataSetDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function copyDataSet(existingSetId, newSetId) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/SYSTEM/DataSet2/%s/Clone/%s"))(existingSetId)(newSetId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString_1(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(string_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(""));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function deleteDataSet(setId) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/SYSTEM/DataSet2/%s/"))(setId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString_1(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(string_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(""));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(4), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export function loadAllDataSets(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/DataSet/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(DataSetMinimal$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(DataSetMinimal$reflection()), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(DataSetMinimal$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export class SaveTranslationDTO extends Record {
    constructor(LanguageCode, Key, Translation) {
        super();
        this.LanguageCode = LanguageCode;
        this.Key = Key;
        this.Translation = Translation;
    }
}

export function SaveTranslationDTO$reflection() {
    return record_type("Api.DataSet.SaveTranslationDTO", [], SaveTranslationDTO, () => [["LanguageCode", string_type], ["Key", string_type], ["Translation", option_type(string_type)]]);
}

export class TranslationTitleDTO extends Record {
    constructor(SetId, Key, Translation) {
        super();
        this.SetId = SetId;
        this.Key = Key;
        this.Translation = Translation;
    }
}

export function TranslationTitleDTO$reflection() {
    return record_type("Api.DataSet.TranslationTitleDTO", [], TranslationTitleDTO, () => [["SetId", string_type], ["Key", string_type], ["Translation", option_type(string_type)]]);
}

export class TranslationBySetIdDTO extends Record {
    constructor(Key, Translation) {
        super();
        this.Key = Key;
        this.Translation = Translation;
    }
}

export function TranslationBySetIdDTO$reflection() {
    return record_type("Api.DataSet.TranslationBySetIdDTO", [], TranslationBySetIdDTO, () => [["Key", string_type], ["Translation", option_type(string_type)]]);
}

export class AllTranslationsBySetIdDTO extends Record {
    constructor(Key, SV, EN, NO, FI) {
        super();
        this.Key = Key;
        this.SV = SV;
        this.EN = EN;
        this.NO = NO;
        this.FI = FI;
    }
}

export function AllTranslationsBySetIdDTO$reflection() {
    return record_type("Api.DataSet.AllTranslationsBySetIdDTO", [], AllTranslationsBySetIdDTO, () => [["Key", string_type], ["SV", option_type(string_type)], ["EN", option_type(string_type)], ["NO", option_type(string_type)], ["FI", option_type(string_type)]]);
}

export function loadDataSetTranslationsBySetId(languageCode, setId) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/DataSet/Translation/%s/%s"))(languageCode)(setId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(TranslationBySetIdDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(TranslationBySetIdDTO$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(TranslationBySetIdDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadAllDataSetTranslationsByKey(languageCode, key) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/DataSet/Translation/%s?key=%s"))(languageCode)(key)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(TranslationTitleDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(TranslationTitleDTO$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(TranslationTitleDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function saveDataSetTranslation(setId, dtos) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/DataSet/Translation/%s"))(setId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString_1(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(list_type(SaveTranslationDTO$reflection())), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dtos));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(2), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(unit_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export function loadAllTranslations(setId) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/DataSet/Translation/all/%s"))(setId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(AllTranslationsBySetIdDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString_1(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(AllTranslationsBySetIdDTO$reflection()), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(AllTranslationsBySetIdDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

